// Le journal des versions affiché dans l'application.
//
// Une seule source : le CHANGELOG.md à la racine du dépôt, écrit par
// `npm run release`. Vite l'injecte à la construction (`define` dans
// vite.config.ts) ; rien n'est donc à recopier à chaque version.
declare const __CHANGELOG__: string;

export interface VersionEntry {
  version: string;
  /** AAAA-MM-JJ, tel qu'écrit dans le journal. */
  date: string;
  changes: string[];
}

// Utiles au développeur, pas à la personne qui lit : `(migration 062)`, `(abc1234)`.
const withoutRefs = (line: string) => line.replace(/\s*\(`[0-9a-f]{7,}`\)\s*$/, '').replace(/\s*\(migrations? [\d, -]+\)/g, '').trim();

/** Les sections `## 0.16.0 — 2026-11-02` et leurs lignes `- …`. PUR. */
export function parseChangelog(text: string): VersionEntry[] {
  const entries: VersionEntry[] = [];
  for (const raw of text.split(/\r?\n/)) {
    const head = raw.match(/^## (\S+) — (\d{4}-\d{2}-\d{2})/);
    if (head) entries.push({ version: head[1]!, date: head[2]!, changes: [] });
    else if (raw.startsWith('- ')) entries.at(-1)?.changes.push(withoutRefs(raw.slice(2)));
  }
  return entries;
}

export const VERSIONS = parseChangelog(__CHANGELOG__);
